import { render, staticRenderFns, recyclableRender, components } from "./ranking-list.vue?vue&type=template&id=a1de6bb4&scoped=true&"
var renderjs
import script from "./ranking-list.vue?vue&type=script&lang=js&"
export * from "./ranking-list.vue?vue&type=script&lang=js&"
import style0 from "./ranking-list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ranking-list.vue?vue&type=style&index=1&id=a1de6bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1de6bb4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/ranking-list/ranking-list.vue"
export default component.exports